<template lang="pug">

  div

    //-
      -
      - Modal IMPRIMIR
      -
      -

    v-dialog(v-model="show" :max-width="format === 'EXCEL' ? '360px' : '600px'" :persistent="loading")

      .dialogHeader

        .dialogHeaderTitle {{ `Imprimir escala de ${currentMonthName} de ${currentYear}` }}

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close" :class="{ 'dialogCloseButton--loading': loading }")

      v-progress-linear(v-if="loading" indeterminate color="green").mb-0.bgwhite

      //-
        - BODY
        -

      .dialogBody

        .dialogBodyContent

          //-
            - PDF SETTINGS: DATE RANGE AND SHIFT
            -

          template(v-if="format === 'PDF'")

            .payrollField.payrollField--no__margin.payrollField--first(v-if="groupReport")
              label.csLabel
                span(v-html="'Período'")
              .csFields.csFields--date
                date-picker(v-model="groupPDFSelectedDateRange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

            .payrollField(:class="{ 'payrollField--no__margin__bottom': groupReport, 'payrollField--no__margin': !groupReport }")
              label.csLabel.csLabel--heightFix
                span(v-html="'Turno'")
              .pdfReportShifts(:class="{ 'pdfReportShifts__scale': !groupReport }")
                .pdfReportShifts__item
                  img(class="pdfReportShifts__item__image" :class="{ 'pdfReportShifts__item__image--loading': loading, 'pdfReportShifts__item__image--selected': selectedShift === 'diurno' }" :disabled="loading" :src="'/images/periodo-diurno.png'" draggable="false" @click="() => onShiftSelect('diurno')")
                .pdfReportShifts__item
                  img(class="pdfReportShifts__item__image" :class="{ 'pdfReportShifts__item__image--loading': loading, 'pdfReportShifts__item__image--selected': selectedShift === 'noturno' }" :disabled="loading" :src="'/images/periodo-noturno.png'" draggable="false" @click="() => onShiftSelect('noturno')")
                .pdfReportShifts__item
                  img(class="pdfReportShifts__item__image" :class="{ 'pdfReportShifts__item__image--loading': loading, 'pdfReportShifts__item__image--selected': selectedShift === 'todos' }" :disabled="loading" :src="'/images/periodo-ambos.png'" draggable="false" @click="() => onShiftSelect('todos')")

          //-
            - EXCEL SETTINGS: CALENDAR DATE RANGE
            -

          template(v-else)

            div
              label.csLabel.csLabel--heightFix
                span
                  | Período
              .radioButtons.mt-2
                div
                  sos-radio(id="month" name="periodo" label="Apenas o mês" :checked="excelCalendarMode" :value="'month'" @click="onExcelCalendarModeClick").sosCheckbox--print
                .mt-3
                  sos-radio(id="calendar" name="periodo" label="Calendário completo" :checked="excelCalendarMode" :value="'calendar'" @click="onExcelCalendarModeClick").sosCheckbox--print

      //-
        - FOOTER
        -

      .dialogFooter.text-right

        //-
          - FECHAR
          -

        sos-button(:disabled="loading" size="medium" color="danger" buttonIconSize="16" @buttonClick="close" buttonLabel="Fechar" buttonIcon="mdi-close").mr-1

        //-
          - GERAR PDF OU EXCEL
          -

        template(v-if="format === 'PDF'")
          sos-button(:disabled="loading" size="medium" color="purple" buttonIconSize="18" @buttonClick="generatePDFReport" buttonLabel="Gerar relatório" buttonIcon="mdi-file-document-plus")
        template(v-if="format === 'EXCEL'")
          sos-button(:disabled="loading" size="medium" color="purple" buttonIconSize="18" @buttonClick="generateExcelReport" buttonLabel="Gerar relatório" buttonIcon="mdi-file-document-plus")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    //-
      -
      - Modal INSCRIÇÃO / ASSINATURA
      -
      -

    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

</template>

<script>

  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'
  import { apiGetUserId } from '@/services/firebase'
  import dateTimeLanguage from '@/constants/dateTimeLanguage'

  import { mapState } from 'vuex'

  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { formatDate, isValidDate, parseDate } from '@/mixins/utils.js'

  import SosRadio from '@/components/SosRadio'
  import SosButton from '@/components/SosButton'
  import SosCheckbox from '@/components/SosCheckbox'
  import SosSelect from '@/components/SosSelect'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SubscriptionModal from '@/modals/SubscriptionModal'

  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'ExportScaleModal',

    components: {
      'sos-radio': SosRadio,
      'sos-select': SosSelect,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'subscription-modal': SubscriptionModal,
      'date-picker': DatePicker,
      'sos-checkbox': SosCheckbox,
    },

    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        // DIALOG VISIBILITY
        show: false,

        // IS BUILDING THE REPORT?
        loading: false,

        excelCalendarMode: 'month',

        groupReport: false,
        format: null,
        currentYear: null,
        currentMonth: null,
        currentMonthName: '',
        selectedShift: null, // Turno escolhido: diurno, noturno ou todos
        startOnMonday: 'no',

        // DATE RANGE
        groupPDFSelectedDateRange: null,

        // DATE PICKER SETTING parou
        lang: dateTimeLanguage,
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
      }),
    },

    watch: {
      show: {
        immediate: true,
        handler: function (show, oldShow)
        {
          if (oldShow === true && show === false) {
            this.reset()
          }
        },
      },
    },

    methods: {
      //
      // ABRIR
      //

      open (args)
      {
        this.format = args.format // PDF ou EXCEL
        this.currentYear = args.currentYear
        this.currentMonth = args.currentMonth
        this.currentMonthName = dateTimeLanguage.formatLocale.months[args.currentMonth - 1]
        this.groupReport = !!this.$route.params.scaleID === false
        this.startOnMonday = args.startOnMonday
        // this.groupReport = args.groupReport || false

        //
        //
        //

        const jsmonth = parseInt(this.currentMonth) - 1

        // Get the first day of the current month
        var firstDay = new Date(this.currentYear, jsmonth, 1)
        // Get the last day of the current month
        var lastDay = new Date(this.currentYear, jsmonth + 1, 0)

        // Format and output the first and last day
        this.groupPDFSelectedDateRange = [formatDate(firstDay), formatDate(lastDay)]

        this.show = true
      },

      //
      // FECHAR
      //

      close ()
      {
        if (this.loading) return false

        this.show = false

        this.reset()
      },

      //
      // LIMPAR / RESETAR TELA
      //

      reset ()
      {
        this.excelCalendarMode = 'month'

        this.groupReport = false
        this.format = null
        this.currentYear = null
        this.currentMonth = null
        this.currentMonthName = ''
        this.selectedShift = null
        this.startOnMonday = 'no'

        // DATE RANGE
        this.groupPDFSelectedDateRange = null
      },

      //
      // GERAR RELATÓRIO DE ESCALA (PDF)
      //

      async generatePDFReport ()
      {
        if (this.loading) return false

        //
        // VERIFICA SE O USUÁRIO LOGADO TEM PERMISSÃO PARA GERAR ESSE RELATÓRIO
        //

        if (freeVersion === false && this.userSession.userCapabilities.relatorioEscala !== true) {
          this.showPlanMessage()
          return false
        }

        //
        //
        //

        if (!['diurno', 'noturno', 'todos'].includes(this.selectedShift)) {
          return this.showMessage('Atenção!', 'Selecione um turno antes de gerar o relatório PDF.')
        }

        //
        //
        //

        if (this.groupReport)
        {
          const [startDateStr, endDateStr] = this.groupPDFSelectedDateRange || []
          const startDate = parseDate(startDateStr)
          const endDate = parseDate(endDateStr)

          if (!startDate || !endDate) {
            return this.showMessage('Atenção!', 'Período selecionado é inválido.')
          }

          if (startDate.getMonth() !== endDate.getMonth() || startDate.getFullYear() !== endDate.getFullYear()) {
            return this.showMessage('Atenção!', 'Você só pode gerar o relatório PDF para datas dentro do mesmo mês.')
          }
        }

        //
        //
        //

        this.loading = true

        const params = new URLSearchParams(this.groupReport ? {
          viewer: apiGetUserId(),
          shift: this.selectedShift,
          group: this.$route.params.groupID,
          start: this.groupPDFSelectedDateRange[0],
          end: this.groupPDFSelectedDateRange[1],
        } : {
          viewer: apiGetUserId(),
          shift: this.selectedShift,
          group: this.$route.params.groupID,
          scale: this.$route.params.scaleID,
          month: this.currentMonth,
          year: this.currentYear,
        })

        const generateEndpoint = this.groupReport ? (
          `api/v1/reports/group-calendar/pdf?${params.toString()}`
        ) : (
          `api/v1/reports/scale-calendar/pdf?${params.toString()}`
        )

        try
        {
          const response = await apiCheckReportStatus(generateEndpoint)

          if (response.httpCode !== 200) {
            this.showMessage(response.title, response.message)
          } else {
            const downloadUrl = response.data.url
            apiOpenReport(downloadUrl, true)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
        this.$emit('setButtonState', false)
      },

      //
      // GERAR RELATÓRIO DE ESCALA (EXCEL)
      //

      generateExcelReport ()
      {
        if (this.loading) return false

        // VERIFICA SE O USUÁRIO LOGADO TEM PERMISSÃO PARA GERAR ESSE RELATÓRIO
        if (freeVersion === false && this.userSession.userCapabilities.relatorioEscala !== true) {
          this.showPlanMessage()
          return false
        }

        const scaleID = this.groupReport ? 'false' : this.$route.params.scaleID

        const checkEndpoint = `checkscalesreportexcel/${this.$route.params.groupID}/${scaleID}/${this.currentMonth}/${this.currentYear}/${this.excelCalendarMode}/${this.startOnMonday}`
        const generateEndpoint = `scalesreportexcel/${this.$route.params.groupID}/${scaleID}/${this.currentMonth}/${this.currentYear}/${this.excelCalendarMode}/${this.startOnMonday}`
        
        this.checkAndGenerateReportFile(checkEndpoint, generateEndpoint)
      },

      //
      // VERIFICAR E GERAR RELATÓRIO
      //

      async checkAndGenerateReportFile (checkEndpoint, generateEndpoint)
      {
        this.loading = true

        try
        {
          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateEndpoint)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
        this.$emit('setButtonState', false)
      },

      //
      //
      //
      // DESABILITA TODAS AS DATAS ANTERIORES A 2016
      // CONSIDERAR FUSO HORÁRIO?
      //
      //
      //

      disableDatesCondition (date, currentValue) {
        return date < new Date(2016, 0, 1)
      },

      //
      // -
      //

      onExcelCalendarModeClick (value)
      {
        this.excelCalendarMode = value
      },

      //
      // Selecionar turno via IMAGEM
      //

      onShiftSelect(shift)
      {
        // JESUS: Informar Elcinei
        if (this.loading) return false

        this.selectedShift = shift
      },

      //
      // -
      //

      showPlanMessage ()
      {
        const planName = this.userSession.planName.name
        const planOrigin = this.userSession.planOrigin

        const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo imprimir a escala. Preciso de ajuda." target="_blank">suporte</a>`
        const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

        if (planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a impressão de escala não está liberada.</p>${textSupport}`)
        } else if (planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a impressão de escala não está liberada.</p>${textSupport}`)
        } else if (planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para imprimir a escala, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
        } else if (planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a impressão de escala não está liberada.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a impressão de escala não está liberada.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a impressão de escala não está liberada.</p>${textSupport}`)
          }
        }
      },
    },
  }

</script>

<style lang="scss">

  .sosCheckbox--print.sosCheckbox .sosCheckboxLabel {
    padding-left: 7px;
    font-size: 15px;
  }

</style>

<style lang="scss" scoped>

  .bgwhite {
    background-color: #FFFFFF;
  }

</style>
